import biesseLogo from "../assets/manufacturer-icons/biesse.svg";
import brandtLogo from "../assets/manufacturer-icons/brandt.svg";
import ceflaLogo from "../assets/manufacturer-icons/cefla.svg";
import formatLogo from "../assets/manufacturer-icons/format.svg";
import heesemannLogo from "../assets/manufacturer-icons/heesemann.svg";
import holzherLogo from "../assets/manufacturer-icons/holz-her.svg";
import holzmaLogo from "../assets/manufacturer-icons/holzma.svg";
import homagLogo from "../assets/manufacturer-icons/homag.svg";
import imaLogo from "../assets/manufacturer-icons/ima.svg";
import masterwoodLogo from "../assets/manufacturer-icons/masterwood.svg";
import morbidelliLogo from "../assets/manufacturer-icons/morbidelli.svg";
import scmLogo from "../assets/manufacturer-icons/scm.svg";
import weekeLogo from "../assets/manufacturer-icons/weeke.svg";
import weinigLogo from "../assets/manufacturer-icons/weinig.svg";
import { slugify } from "../slug.js";

/**
 * Brand wordmarks we have artwork for, keyed by the same slug the manufacturer pages use.
 *
 * Not every brand in the catalogue is here — a missing logo just means the pages show the
 * name instead. The files are dark navy/grey wordmarks, so they only work on a light
 * background; never put them on the blue hero.
 */
const MANUFACTURER_LOGOS = {
  biesse: biesseLogo,
  brandt: brandtLogo,
  cefla: ceflaLogo,
  "format-4": formatLogo,
  heesemann: heesemannLogo,
  "holz-her": holzherLogo,
  holzma: holzmaLogo,
  homag: homagLogo,
  ima: imaLogo,
  masterwood: masterwoodLogo,
  morbidelli: morbidelliLogo,
  scm: scmLogo,
  weeke: weekeLogo,
  weinig: weinigLogo,
};

/**
 * Logo URL for a manufacturer name, or null when we have no artwork for it.
 * @param {string} name e.g. "Holz-Her"
 */
export function manufacturerLogo(name) {
  return MANUFACTURER_LOGOS[slugify(name)] || null;
}

export default MANUFACTURER_LOGOS;
